
import * as React from 'react';
import styled from 'styled-components';
import * as Highcharts from 'highcharts/highstock';

import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';
import { HighChart } from '@process-advisor/process-miner/components/charts/highChart/highChart';
import { Dropdown } from '@process-advisor/process-miner/components/shared/dropdown';
import { Section } from '@process-advisor/process-miner/components/shared/section';
import { SingleBlock } from '@process-advisor/process-miner/components/layout/singleBlock';

export type Data = []

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;

export const EventHistory: React.FC = () => {
    const [data, setData] = React.useState<Data[]>([]);
    const [metric, setMetric] = React.useState<string>('events');
    const [title, setTitle] = React.useState<string>('Events Created');
    const [label, setLabel] = React.useState<string>('Events');

    const optionsMetrics = [
        { value: 'events', label: 'Events' },
    ];
    
    const onMetricChange = (metric: string) => {
        setMetric(metric);
        if (metric === 'events') {setTitle('Events Created'); setLabel('Events')}
        setData(apiProvider.analyticsEventHistory({metric: metric}));
    };

    React.useEffect(() => {
        setMetric('events');
        setData(apiProvider.analyticsEventHistory({metric: metric}));

    }, []);

    React.useEffect(() => {
        const listener = () =>
            setData(apiProvider.analyticsEventHistory({metric: metric}));
        listener();
        apiProvider.on(Event.updateEvents, listener);
        apiProvider.on(Event.applyFilter, listener);
        apiProvider.on(Event.resetFilter, listener);

        return () => {
            apiProvider.off(Event.updateEvents, listener);
            apiProvider.off(Event.applyFilter, listener);
            apiProvider.off(Event.resetFilter, listener);
        };
    }, []);


    const options: Highcharts.Options = {
        chart: {
            style: {
                fontFamily: 'system-ui'
            },
            borderWidth: 2,
            borderColor: '#E0E0E0'
        },
        title: {
            text: title,
            style: {
                fontSize: '14px',
                fontWeight: 'bold',
            },
        },
        plotOptions: {
            line: {
                dataGrouping: {
                    approximation: 'average',
                    units: [
                        [
                            'month', [1]],
                    ],
                },
            },
        },
        legend: {
            enabled: false,
        },
        credits: {
            enabled: false,
        },
        series: [
            {
                name: label,
                type: 'spline',
                color: '#0B66E4',
                data,
                tooltip: {
                    valueDecimals: 0,
                },
            },
        ],
    };

    return (
        <Wrapper>
            <SingleBlock width="10%">
                <Section title='Metric:'/>
            </SingleBlock>
            <SingleBlock width="20%">
                <Dropdown
                    options={optionsMetrics}
                    onChange={onMetricChange}
                    value={metric}/>
            </SingleBlock>
            <SingleBlock width="70%"/>

            <HighChart options={options} constructorType='stockChart' />
        </Wrapper>
    );
};
